import { Toolbar, Item, DataGridRef } from "devextreme-react/data-grid";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { openPopup } from "../../helper/DxHelper";
import { basicSettings } from "../../helper/GridCreator/gridConfig";
import GridCreator from "../../helper/GridCreator/GridCreator";
import { StockPriceRegister, GridType } from "../../types/types";
import { StockPriceRegisterDS } from "../../dataSources/StockPriceRegisterDS";
import { stockPriceRegisterActions } from "../../redux/stock-price-register/stock-price-register-slice";
import { useParams } from "react-router";
import Insert from "./Insert";
import Update from "./Update";
import { householdActions } from "@/redux/household/household-slice";
import Delete from "./Delete";
import { PopupRef } from "devextreme-react/cjs/popup";
import { useAppSelector } from "@/hooks/useAppSelector";
import { ColumnCellTemplateData } from "devextreme/ui/data_grid";

export default function StockPriceRegisterList() {
  const params = useParams();
  const updatePopupRef = useRef<PopupRef>(null);
  const removePopupRef = useRef<PopupRef>(null);
  const insertPopupRef = useRef<PopupRef>(null);
  const dispatch = useDispatch();
  const datagridRef = useRef<DataGridRef<StockPriceRegister, string>>(null);
  const { code } = useAppSelector((state) => state.stock.editStockData);
  const ds = StockPriceRegisterDS(params.id as string);

  useEffect(() => {
    dispatch(householdActions.setHeader({ title: `${code} Details`, content: "" }));
  }, []);

  const addButtonOptions = {
    icon: "plus",
    onClick: () => {
      openPopup(insertPopupRef);
    },
  };

  function renderToolbar() {
    return (
      <Toolbar>
        <Item
          location="after"
          locateInMenu={"auto"}
          widget="dxButton"
          options={addButtonOptions}
          cssClass="dx-datagrid-insert-button"
        />
        <Item name="columnChooserButton" location="after" />
        <Item name="searchPanel" location="after" />
      </Toolbar>
    );
  }

  const gridSettings: GridType<StockPriceRegister, string> = {
    ...basicSettings,
    ref: datagridRef,
    id: "stockPriceRegisterGrid",
    dataSource: ds,
    toolbar: renderToolbar,
    columns: [
      {
        key: "cmd",
        width: 90,
        cellRender: cmdCellRender,
        allowExporting: false,
        allowHiding: false,
        allowResizing: false,
        showInColumnChooser: false,
      },
      {
        key: "timestamp",
        dataType: "date",
        dataField: "timestamp",
        visible: true,
        sortOrder: "asc",
        allowEditing: false,
        caption: "Date",
        width: 300,
      },
      {
        key: "value",
        dataType: "number",
        dataField: "close",
        visible: true,
        alignment: "left",
        allowEditing: false,
        caption: "Value",
        format: "$ #,##0.##",
      },
    ],
  };

  function cmdCellRender(e: ColumnCellTemplateData<StockPriceRegister>) {
    return (
      <div className="flex items-center gap-x-2">
        <button
          title="edit"
          onClick={() => {
            openPopup(updatePopupRef);
            dispatch(stockPriceRegisterActions.setEditDataId(e.row.data.id));
          }}
        >
          <img src="/icons/edit-icon.svg" />
        </button>
        <button
          title="remove"
          onClick={() => {
            openPopup(removePopupRef);
            dispatch(stockPriceRegisterActions.setEditDataId(e.row.data.id));
          }}
        >
          <img src="/icons/trash-icon.svg" />
        </button>
      </div>
    );
  }

  return (
    <>
      <Insert popupRef={insertPopupRef} datagridRef={datagridRef} />
      <Update popupRef={updatePopupRef} datagridRef={datagridRef} />
      <Delete popupRef={removePopupRef} datagridRef={datagridRef} />
      <GridCreator {...gridSettings} />
    </>
  );
}
